package br.com.vvrefeicoes.portal.core.util

import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.minus
import kotlinx.datetime.plus

data class WeekRange(
    val index: Int,
    val startDay: Int,
    val endDay: Int,
) {
    val label: String
        get() = "${startDay.pad2()}-${endDay.pad2()}"
}

private fun Int.pad2(): String = toString().padStart(2, '0')

object MonthCalendar {
    private val monthNames =
        listOf(
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
        )

    private val monthShortNames =
        listOf(
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
        )

    fun label(period: MonthPeriod): String = "${monthNames[period.month - 1]}/${period.year}"

    fun monthName(month: Int): String = monthNames[month - 1]

    fun shortLabel(period: MonthPeriod): String = "${monthShortNames[period.month - 1]}/${period.year.toString().takeLast(2)}"

    fun weeksOf(period: MonthPeriod): List<WeekRange> {
        val first = LocalDate(period.year, period.month, 1)
        val lastDay = daysInMonth(period.year, period.month)
        val offset = (first.dayOfWeek.ordinal + 1) % 7
        val count = (offset + lastDay + 6) / 7
        return (0 until count).map { index ->
            val start = index * 7 - offset + 1
            WeekRange(index = index, startDay = maxOf(start, 1), endDay = minOf(start + 6, lastDay))
        }
    }

    fun daysInMonth(
        year: Int,
        month: Int,
    ): Int = LocalDate(year, month, 1).plus(1, DateTimeUnit.MONTH).minus(1, DateTimeUnit.DAY).day
}
